import {
     RESET_GENERAL_STATE,
     SET_AFTER_LOGIN,
     SET_CURRENT_TAB,
     SET_IS_CALLED_CURRENT_USER,
     SET_IS_LOADING,
     SET_IS_NOTICE_LOADING,
     SET_IS_WAITING_ORDER,
     SET_IS_WAITING,
     SET_MESSAGE,
     SET_OVERLAY,
     SET_PAGE_LOADING,
     SET_REMOVE_LOADING,
     SET_SHOW_COMPONENT,
     SET_SHOW_EDIT_POPUP,
     SET_SHOW_LOGIN_AS,
     SET_SHOW_POPUP_DETAIL,
     SET_SHOW_POPUP,
     SET_SHOW_RELATED_OBJECT_WARNING_POPUP,
     SET_SHOW_REMOVE_POPUP,
     SET_SHOW_UNSAVED_CHANGE_POPUP,
     SET_SHOW,
     SET_SIDEBAR_SHOW,
     TOGGLE_THEME,
} from '../actions/types';

export const INITIAL_STATE = {
     darkMode: false,
     overlay: false, // When is opening select account or profile, add overlay to main content
     afterLogin: null,
     currentTab: null,
     isCalledCurrentUser: false,
     isLoading: false,
     isNoticeLoading: false,
     isWaiting: false,
     isWaitingOrder: false,
     message: null,
     pageLoading: false,
     relatedWarningMessage: '',
     removeLoading: false,
     show: null,
     showCheckRemovePopup: null,
     showComponent: null,
     showEditPopup: null,
     showLoginAs: false,
     showPopup: false,
     showPopupDetail: null,
     showRelatedObjectWarningPopup: null,
     showRemovePopup: null,
     showUnsavedChangePopup: false,
     sidebarShow: true,
};

const generalReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case RESET_GENERAL_STATE: {
               const payload = action.payload;

               if (payload) {
                    return { ...state, ...payload };
               }

               return INITIAL_STATE;
          }
          case SET_OVERLAY:
               return { ...state, overlay: action.payload };
          case SET_SIDEBAR_SHOW:
               return { ...state, sidebarShow: action.payload };
          case TOGGLE_THEME:
               return { ...state, darkMode: !state.darkMode };
          case SET_SHOW_UNSAVED_CHANGE_POPUP:
               return { ...state, showUnsavedChangePopup: !state.showUnsavedChangePopup };
          case SET_SHOW_POPUP:
               return { ...state, showPopup: !state.showPopup };
          case SET_SHOW_REMOVE_POPUP:
               return { ...state, showRemovePopup: action.payload };
          case SET_SHOW_RELATED_OBJECT_WARNING_POPUP:
               return {
                    ...state,
                    showRelatedObjectWarningPopup: action.payload,
                    relatedWarningMessage: action.message,
               };
          case SET_SHOW_POPUP_DETAIL:
               return { ...state, showPopupDetail: action.payload };
          case SET_SHOW_EDIT_POPUP:
               return { ...state, showEditPopup: action.payload };
          case SET_SHOW_COMPONENT:
               return { ...state, showComponent: action.payload };
          case SET_IS_WAITING:
               return { ...state, isWaiting: action.payload };
          case SET_IS_WAITING_ORDER:
               return { ...state, isWaitingOrder: action.payload };
          case SET_IS_CALLED_CURRENT_USER:
               return { ...state, isCalledCurrentUser: action.payload };
          case SET_IS_LOADING:
               return { ...state, isLoading: action.payload };
          case SET_IS_NOTICE_LOADING:
               return { ...state, isNoticeLoading: action.payload };
          case SET_REMOVE_LOADING:
               return { ...state, removeLoading: action.payload };
          case SET_CURRENT_TAB:
               return { ...state, currentTab: action.payload };
          case SET_PAGE_LOADING:
               return { ...state, pageLoading: action.payload };
          case SET_SHOW:
               return { ...state, show: action.payload };
          case SET_SHOW_LOGIN_AS:
               return { ...state, showLoginAs: action.payload };
          case SET_AFTER_LOGIN:
               return { ...state, afterLogin: action.payload };
          case SET_MESSAGE:
               return { ...state, message: action.payload };
          default:
               return state;
     }
};

export default generalReducer;
